// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2npJz","badges":"styles_badges__1Lq8m"};